/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Requestacceptname2Inputs */

const en_requestacceptname2 = /** @type {(inputs: Requestacceptname2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Accept ${i?.name}`)
};

const de_requestacceptname2 = /** @type {(inputs: Requestacceptname2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} annehmen`)
};

/**
* | output |
* | --- |
* | "Accept {name}" |
*
* @param {Requestacceptname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestacceptname2 = /** @type {((inputs: Requestacceptname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestacceptname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestacceptname2(inputs)
	return de_requestacceptname2(inputs)
});
export { requestacceptname2 as "requestAcceptName" }